import React from 'react';
import { NavLink } from 'react-router-dom';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="hero bg-gradient-to-r from-green-100 to-yellow-100 py-20">
        <div className="container mx-auto px-4 text-center">
          <div className="max-w-4xl mx-auto">
            <img src="Images/main.png" alt="Focused Tennis Player" className="mx-auto mb-8 rounded-lg shadow-lg" />
            <h1 className="text-5xl font-bold text-green-800 mb-4">Master Every Point. Track Every Stat.</h1>
            <p className="text-xl text-gray-700 mb-8">
              The complete system for tennis players: Online match tracking, physical journals, and the definitive guide to mental toughness.
            </p>
            <div className="flex justify-center space-x-4">
              <NavLink to="/online-match-tracking" className="bg-green-500 hover:bg-green-600 text-white font-semibold py-3 px-6 rounded-full text-lg transition duration-300">
                Get Started for Free
              </NavLink>
              <NavLink to="/mental-toughness-book" className="bg-yellow-500 hover:bg-yellow-600 text-green-800 font-semibold py-3 px-6 rounded-full text-lg transition duration-300">
                Tennis Mental Toughness Book
              </NavLink>
            </div>
          </div>
        </div>
      </section>

      {/* Choose Your Path Trio */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-green-800 mb-12">Choose Your Path</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-green-50 p-8 rounded-lg shadow-md text-center">
              <h3 className="text-2xl font-semibold text-green-800 mb-4">Digital Tracking</h3>
              <p className="text-gray-700 mb-6">Link to the Online Match Service.</p>
              <NavLink to="/online-match-tracking" className="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded-md transition duration-300">
                Learn More
              </NavLink>
            </div>
            <div className="bg-yellow-50 p-8 rounded-lg shadow-md text-center">
              <h3 className="text-2xl font-semibold text-green-800 mb-4">Physical Tracking</h3>
              <p className="text-gray-700 mb-6">Link to the Match & Practice Log Books.</p>
              <NavLink to="/log-book-hub" className="bg-yellow-500 hover:bg-yellow-600 text-green-800 font-semibold py-2 px-4 rounded-md transition duration-300">
                Learn More
              </NavLink>
            </div>
            <div className="bg-green-50 p-8 rounded-lg shadow-md text-center">
              <h3 className="text-2xl font-semibold text-green-800 mb-4">Mental Mastery</h3>
              <p className="text-gray-700 mb-6">Link to the Mental Toughness Book (Physical/Digital/Audio).</p>
              <NavLink to="/mental-toughness-book" className="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded-md transition duration-300">
                Learn More
              </NavLink>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Bundle */}
      <section className="py-16 bg-gradient-to-r from-green-100 to-yellow-100">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-green-800 mb-8">Featured Bundle: The Ultimate Player Kit</h2>
          <p className="text-lg text-gray-700 mb-8">Service Access + Books + Pen.</p>
          <NavLink to="/extras-shop" className="bg-yellow-500 hover:bg-yellow-600 text-green-800 font-semibold py-3 px-6 rounded-full text-lg transition duration-300">
            Shop Now
          </NavLink>
        </div>
      </section>

      {/* SEO Footer */}
      <footer className="bg-gray-800 text-white py-8">
        <div className="container mx-auto px-4 text-center">
          <p className="text-sm">
            Keywords: Tennis stats app, Tennis training journal, Mental game of tennis.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;

